import { render } from "./book-introduction.vue?vue&type=template&id=1e780976&scoped=true"
import script from "./book-introduction.vue?vue&type=script&lang=js"
export * from "./book-introduction.vue?vue&type=script&lang=js"

import "./book-introduction.vue?vue&type=style&index=0&id=1e780976&scoped=true&lang=css"

import exportComponent from "/Users/aiden/Desktop/hujian/hongyu/edu-web-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e780976"]])

export default __exports__